// extracted by mini-css-extract-plugin
module.exports = {"hidden":"_0940612"};